// removed by extract-text-webpack-plugin
module.exports = {"container":"_2Mq_izc_3BLDZx4PTQOH7U_0","branding":"OKyuRemPglqcH2sUhO41V_0","title":"Ozry4xEttOuAVXW92bs7q_0","subtitle":"_3tn_mRPEt6vxS99ISsfE-G_0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-54837f36","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/AppHeader.vue
// module id = 9kth
// module chunks = 1